import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: 95vw;
  .fb-post {
    max-width: 95vw !important;
    margin: auto;
    height: 100%;
    display: flex;
    justify-content: space-around;
    padding-bottom: 2rem;
  }
`;
